import { getUserIdByOccupantId } from '../base/participants';
import { CHANGE_DISPLAY_LOBBY, CHANGE_DISPLAY_OFFLINE, CHANGE_DISPLAY_ONLINE, CHANGE_DISPLAY_PARTICIPANE, CHANGE_DISPLAY_RAISED_HAND, CHANGE_TAB_PARTICIPANT, DATA_ATTENDANCE, PARTICIPANTS_PANE_CLOSE, SET_VOLUME } from './actionTypes';
/**
 * Sets the volume for a thumbnail's audio.
 *
 * @param {string} participantId - The participant ID associated with the audio.
 * @param {string} volume - The volume level.
 * @returns {{
 *     type: SET_VOLUME,
 *     participantId: string,
 *     volume: number
 * }}
 */
export function setVolume(participantId, volume) {
    return {
        type: SET_VOLUME,
        participantId,
        volume
    };
}
/**
 * Action to close the participants pane.
 *
 * @returns {Object}
 */
export const close = () => {
    return {
        type: PARTICIPANTS_PANE_CLOSE
    };
};
export const changeTabParticipant = (payload) => {
    return {
        type: CHANGE_TAB_PARTICIPANT,
        payload
    };
};
export const changeDisplayLobby = (payload) => {
    return {
        type: CHANGE_DISPLAY_LOBBY,
        payload
    };
};
export const changeDisplayParticipant = (payload) => {
    return {
        type: CHANGE_DISPLAY_PARTICIPANE,
        payload
    };
};
export const changeDisplayRaisedHand = (payload) => {
    return {
        type: CHANGE_DISPLAY_RAISED_HAND,
        payload
    };
};
export const changeDisplayOnline = (payload) => {
    return {
        type: CHANGE_DISPLAY_ONLINE,
        payload
    };
};
export const changeDisplayOffline = (payload) => {
    return {
        type: CHANGE_DISPLAY_OFFLINE,
        payload
    };
};
export const dataAttendance = (payload) => {
    return {
        type: DATA_ATTENDANCE,
        payload
    };
};
export const fetchDataAttendance = (dataAttendanceResponse) => {
    const fetchDataAttendanceAction = async () => {
        try {
            const list = APP.store.getState()['features/base/participants'].remote;
            const listConvert = [...list];
            const listInfo = [...listConvert.map(l => l[1]), APP.store.getState()['features/base/participants'].local];
            let _participant;
            if (Object.keys(dataAttendanceResponse).length && (dataAttendanceResponse?.participants).length) {
                _participant = dataAttendanceResponse?.participants?.map((p) => {
                    const isP = listInfo.find((p1) => getUserIdByOccupantId(APP.store.getState(), p1?.id) == p.userId);
                    if (isP) {
                        return { ...p, displayName: isP.name };
                    }
                    else
                        return p;
                });
            }
            APP.store.dispatch(dataAttendance(_participant));
        }
        catch (error) {
            // return error.response;
            console.log("error: fetchDataAttendance");
        }
    };
    return fetchDataAttendanceAction;
};
